import React from 'react';

import styled, {keyframes} from 'styled-components';

interface Props {
  height?: string;
  width?: string;
  marginBottom?: string;
  className?: string;
  color?: string;
  verticalAlign?: string;
}
export const LoadingLine = ({
  height,
  width = '100%',
  marginBottom = '0',
  className = '',
  color = '#ccc',
  verticalAlign = 'initial',
}: Props): JSX.Element => (
  <StyledLoadingLineContainerDiv
    marginBottom={marginBottom}
    width={width}
    className={className}
    verticalAlign={verticalAlign}
  >
    <StyledGradientDiv height={height} color={color} />
  </StyledLoadingLineContainerDiv>
);

const StyledLoadingLineContainerDiv = styled.div<{
  width: number | string;
  marginBottom: string;
  verticalAlign: string;
}>`
  position: relative;
  overflow: hidden;
  width: ${({width}) => width};
  margin-bottom: ${({marginBottom}) => marginBottom};
  vertical-align: ${({verticalAlign}) => verticalAlign};
  border-radius: 4px;
`;

const horizontalScrollKeyFrame = keyframes`
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(100%);
    }
`;

const StyledGradientDiv = styled.div<{
  height: string | undefined;
  color: string;
}>`
  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${horizontalScrollKeyFrame};
  animation-timing-function: linear;

  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    ${({color}) => color} 50%,
    rgba(0, 0, 0, 0) 100%
  );
  ${({height}) => (height != null ? `height: ${height}` : '')};
`;
